/**
 * Constants for survey configuration
 */

export const STORAGE_NAME = 'survey-storage';

export const STORE_NAME_DEV_TOOLS = 'survey-store';

export const CALL_THRESHOLD = 5;
